import { useRouteError } from 'react-router';

/** errorElement для маршрутов: показывает сообщение вместо белого экрана. */
export function RouteError() {
  const error = useRouteError() as { message?: string; statusText?: string } | undefined;
  const detail = error?.statusText || error?.message || 'Неизвестная ошибка';

  return (
    <div className="mx-auto max-w-lg space-y-3 py-16 text-center">
      <h1 className="text-lg font-semibold text-ink">Что-то сломалось на этой странице</h1>
      <p className="text-sm text-muted">{detail}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-lg bg-accent px-3 py-1.5 text-sm font-medium text-white hover:bg-accent-600"
      >
        Перезагрузить
      </button>
    </div>
  );
}
